import { WINDOW } from '@sentry/react';
import { appRouterInstrumentation } from './appRouterRoutingInstrumentation.js';
import { pagesRouterInstrumentation } from './pagesRouterRoutingInstrumentation.js';

/**
 * Instruments the Next.js Clientside Router.
 */
function nextRouterInstrumentation(
  startTransactionCb,
  startTransactionOnPageLoad = true,
  startTransactionOnLocationChange = true,
) {
  const isAppRouter = !WINDOW.document.getElementById('__NEXT_DATA__');
  if (isAppRouter) {
    appRouterInstrumentation(startTransactionCb, startTransactionOnPageLoad, startTransactionOnLocationChange);
  } else {
    pagesRouterInstrumentation(startTransactionCb, startTransactionOnPageLoad, startTransactionOnLocationChange);
  }
}

export { nextRouterInstrumentation };
//# sourceMappingURL=nextRoutingInstrumentation.js.map
